import React, { FC } from 'react';
import { Input, InputProps } from 'formik-antd';
import { useFormikContext } from 'formik';

export const TrimmedFormikInput: FC<InputProps> = (props) => {
  const { setFieldValue } = useFormikContext();

  return (
    <Input
      {...props}
      onBlur={(v) => {
        setFieldValue(props.name, v.target.value.trim());
      }}
    />
  );
};
